import {useContext} from 'react';
import {MobXProviderContext} from 'mobx-react';

export const useStore = <TStore = unknown>(): TStore => {
  const {store} = useContext(MobXProviderContext) as {store: TStore};
  return store;
};
